import { c as _c } from "react/compiler-runtime";
import usePDPGetStockAvailability from 'data-hooks/usePDPGetStockAvailability';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import useBackgroundProductBasicDetails from 'data-hooks/useProductBasicDetails/useBackgroundProductBasicDetails';
import useReadProductBasicDetails from 'data-hooks/useProductBasicDetails/useReadProductBasicDetails';
import usePDPGetBasicDetails from '../usePDPGetBasicDetails';
import usePDPCreateProductOptions from './usePDPCreateProductOptions';
import usePDPRedirectDoubleQuery from '../usePDPRedirectDoubleQuery';
const useMockHook = () => null;
const useBasicDetails = isNewConsumerApp ? useMockHook : usePDPGetBasicDetails;
const useBackgroundBasicDetails = isNewConsumerApp ? useBackgroundProductBasicDetails : useMockHook;
const useReadBasicDetails = isNewConsumerApp ? useReadProductBasicDetails : useMockHook;
const usePDPCreateContextValue = (t0, t1) => {
  const $ = _c(31);
  let t2;
  if ($[0] !== t0) {
    t2 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    slug,
    isEditOrder: t3,
    isQuickView: t4,
    pdpIsModularBYOProduct: t5,
    pdpVariantSkuOverride: t6,
    productOptions: initialProductOptions
  } = t2;
  const isEditOrder = t3 === undefined ? false : t3;
  const isQuickView = t4 === undefined ? false : t4;
  const pdpIsModularBYOProduct = t5 === undefined ? false : t5;
  const pdpVariantSkuOverride = t6 === undefined ? null : t6;
  let t7;
  if ($[2] !== t1) {
    t7 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const {
    skip: t8
  } = t7;
  const skip = t8 === undefined ? false : t8;
  usePDPRedirectDoubleQuery();
  let t9;
  if ($[4] !== slug) {
    t9 = {
      slug
    };
    $[4] = slug;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== skip) {
    t10 = {
      skip
    };
    $[6] = skip;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const basicDetailsExistingApp = useBasicDetails(t9, t10);
  let t11;
  if ($[8] !== skip) {
    t11 = {
      skip
    };
    $[8] = skip;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const basicDetailsQueryRef = useBackgroundBasicDetails(null, slug, t11);
  const t12 = basicDetailsExistingApp?.data?.id;
  const t13 = !isQuickView && !isEditOrder;
  let t14;
  if ($[10] !== basicDetailsQueryRef || $[11] !== initialProductOptions || $[12] !== pdpVariantSkuOverride || $[13] !== slug || $[14] !== t12 || $[15] !== t13) {
    t14 = {
      id: t12,
      slug,
      basicDetailsQueryRef,
      pdpVariantSkuOverride,
      shouldUpdateQueryParam: t13,
      initialProductOptions
    };
    $[10] = basicDetailsQueryRef;
    $[11] = initialProductOptions;
    $[12] = pdpVariantSkuOverride;
    $[13] = slug;
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== skip) {
    t15 = {
      skip
    };
    $[17] = skip;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  const {
    atoms,
    productOptions
  } = usePDPCreateProductOptions(t14, t15);
  const basicDetailsNewApp = useReadBasicDetails(basicDetailsQueryRef);
  const basicDetails = isNewConsumerApp ? basicDetailsNewApp : basicDetailsExistingApp;
  let t16;
  if ($[19] !== basicDetails || $[20] !== productOptions) {
    t16 = {
      basicDetails,
      productOptions
    };
    $[19] = basicDetails;
    $[20] = productOptions;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  const stockAvailability = usePDPGetStockAvailability(t16);
  const t17 = basicDetails?.data?.id || null;
  let t18;
  if ($[22] !== atoms || $[23] !== basicDetails || $[24] !== pdpIsModularBYOProduct || $[25] !== pdpVariantSkuOverride || $[26] !== productOptions || $[27] !== slug || $[28] !== stockAvailability || $[29] !== t17) {
    t18 = {
      atoms,
      basicDetails,
      id: t17,
      pdpIsModularBYOProduct,
      pdpVariantSkuOverride,
      pdpIsAvailableInSizesOpen: true,
      productOptions,
      stockAvailability,
      slug
    };
    $[22] = atoms;
    $[23] = basicDetails;
    $[24] = pdpIsModularBYOProduct;
    $[25] = pdpVariantSkuOverride;
    $[26] = productOptions;
    $[27] = slug;
    $[28] = stockAvailability;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  return t18;
};
export default usePDPCreateContextValue;